/**
 * NF-944: Controller for managing notifications.
 * @constructor
 */
/**
 * Initializes a new instance of the NotificationsController.
 */
function NotificationsController() {
    // Initialize the controller
    this.init.apply(this, arguments);
}

// Dependency injection for the controller
NotificationsController.$inject = ['$scope', '$state', '$stateParams', 'NotificationService', '$q', '$Loading', '$message', '$translationService', '$filter', 'DeviceService'];

// Define the prototype methods for NotificationsCtrl
NotificationsController.prototype = {
    total: 0, // Total number of notifications
    /** @type {NotificationModel[]} lists */
    list: [],
    /**
     * Initializes the controller with necessary services and scope.
     * @param {angular.IScope} $scope - AngularJS scope object
     * @param {ui.IStateService} $state - State service for navigation
     * @param {ui.IStateParamsService} $stateParams - State service for navigation
     * @param {NotificationService} NotificationService - Service for managing notifications
     * @param {angular.IQService} $q - AngularJS promise service
     * @param {$Loading} $Loading - Loading service for showing/hiding loading indicators
     * @param {$message} $message - Service for displaying messages
     * @param {$translationService} $translationService
     * @param {angular.IFilterService} $filter - AngularJS filter service
     * @param {DeviceService} DeviceService
     */
    init: function ($scope, $state, $stateParams, NotificationService, $q, $Loading, $message, $translationService, $filter, DeviceService) {
        this.$scope = $scope;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.notificationService = NotificationService;
        this.$q = $q;
        this.$Loading = $Loading;
        this.$message = $message;
        this.$translationService = $translationService;
        this.$filter = $filter;
        this.deviceService = DeviceService;


        this.$element = $('#internal-notifications-page');

        // Load notifications
        this.refresh().finally(this.$Loading.blockUI());

        this.deviceService.onGoBackButton($scope, ()=>{
            this.back();
        });
    },

    /**
     * Navigates back to the home page.
     */
    back: function () {
        this.$state.go('internal.home');
    },

    /**
     * Loads notifications from the service.
     * @returns {angular.IPromise<NotificationModel[]>} A promise that resolves with the list of notifications.
     */
    loadData() {
        return this.notificationService.getNotifications();
    },

    /**
     * Opens the menu.
     * @param {Function} $mdOpenMenu - Function to open the menu.
     * @param {Object} ev - Event object.
     */
    openMenu: function ($mdOpenMenu, ev) {
        $mdOpenMenu(ev); // Open the menu with the event
    },

    /**
     * Marks all notifications as read.
     */
    cleanAll: function () {
        this.notificationService.getNotificationMarkAllAsRead()
            .then(() => {
                // Refresh notifications after marking as read
                return this.refresh();
            }, this.$message.error)
            .finally(this.$Loading.blockUI());
    },

    /**
     * Navigates to notification settings.
     */
    openSettings: function () {
        this.$state.go('internal.notifications_settings'); // Navigate to the notification settings page
    },

    /**
     * Reloads notifications.
     * @returns {angular.IPromise<*>} A promise that resolves when the refresh is complete.
     */
    onReload: function () {
        return this.refresh();
    },

    /**
     * Refreshes the notification list.
     * @returns {angular.IPromise<*>} A promise that resolves with the updated list of notifications.
     */
    refresh: function () {
        return this.loadData().then((list) => {
            // Translate message
            list.forEach((item) => {
                if (!item.Sender) {
                    item.Sender = {
                        Name: 'Neofleet'
                    }
                }
                
                item.Title = item.Subject;

            // from NF-1227 (2026.1) the translations on the list item (Subject, Message) is done on server to avoid duplicated translations on UI and server

                /** @type {KeyValueData} */
            //     let keyValueData = {};
            //     if (item.KeyValueData) {
            //         try{
            //             keyValueData = JSON.parse(item.KeyValueData);
            //         } catch (e) {
            //         }
            //     } else {
            //         keyValueData = {
            //             ChargingPoint: item.ChargingPoint,
            //             Vehicle: item.Vehicle,
            //             Comment: item.Message
            //         }
            //     }
            //     switch (item.Type) {
            //         // NF-1227
            //         case 'OrderComment':
            //             item.Title = this.$translationService.formatTranslation('NotificationSubject_OrderComment');
            //             item.Message = keyValueData.Comment;
            //             break;

            //         case 'EventComment':
            //             item.Title = this.$translationService.formatTranslation('NotificationSubject_EventComment');
            //             item.Message = keyValueData.Comment;
            //             break;

            //         // // NF-1227
            //         case 'EventAssignment':
            //             item.Title = this.$translationService.formatTranslation('NotificationSubject_EventAssignment');
            //             item.Message = this.$translationService.formatTranslation('NotificationBody_EventAssignment', keyValueData.Type);
            //             break;

            //         // // NF-1227
            //         case 'OrderAssignment':
            //             item.Title = this.$translationService.formatTranslation('NotificationSubject_OrderAssignment');                        
            //             item.Message = this.$translationService.formatTranslation('NotificationBody_OrderAssignment', keyValueData.Title);
            //             break;

            //         //NF-948: ChargeHasEnded
            //         case 'ChargeHasEnded':
            //             // Your charge was completed at {ChargingPoint}
            //             item.Title = this.$translationService.formatTranslation('VehicleChargeFinished', keyValueData.ChargingPoint);

            //             // The charge of your vehicle 1-TDX-251 has ended on 10/10/2024 at 13:21 on charging station 09.
            //             item.Message = this.$translationService.formatTranslation('ChargeHasEnded', keyValueData.Vehicle, this.$filter('date')(keyValueData.Date, 'dd/MM/yyyy'), keyValueData.Time, keyValueData.ChargingPoint);
            //             break;

            //         //NF-962: ReleaseChargingPoint
            //         case 'ReleaseChargingPoint':
            //             // You must release the charging point
            //             item.Title = this.$translationService.formatTranslation('YouMustReleaseChargingPoint', keyValueData.ChargingPoint);

            //             // You must move your vehicle {0} to free up the charging point {1} so that another driver can charge.
            //             item.Message = this.$translationService.formatTranslation('ReleaseChargingPoint', keyValueData.Vehicle, keyValueData.ChargingPoint);
            //             break;

            //         // NF-1173: CancelReleaseChargingPoint
            //         case 'CancelReleaseChargingPoint':
            //             // Request to release the charging point cancelled
            //             item.Title = this.$translationService.formatTranslation('RequestToReleaseChargingPointCancelled');

            //             // The request to move your vehicle from charging point {0} has been cancelled. \n\nNo further action is needed.
            //             item.Message = this.$translationService.formatTranslation('RequestToReleaseChargingPointCancelledBody', keyValueData.ChargingPoint);
            //             break;    

            //         //NF-961: VehicleNotChargingNormally
            //         case 'VehicleNotChargingNormally':
            //             // Your vehicle is not charging normally
            //             item.Title = this.$translationService.formatTranslation('YourVehicleNotChargingNormally');

            //             // Your vehicle is not charging correctly on the charging station {0}.
            //             item.Message = this.$translationService.formatTranslation('VehicleNotChargingNormally', keyValueData.ChargingPoint);
            //             break;

            //         //NF-958: ConnectToChargingPointCancelledChargingPointOffline
            //         case 'ConnectToChargingPointCancelledChargingPointOffline':
            //             // The charging point is now out of service
            //             item.Title = this.$translationService.formatTranslation('ChargingPointOutOfService');

            //             // The charging point {0} recently assigned to you is now out of service.
            //             item.Message = this.$translationService.formatTranslation('ConnectToChargingPointCancelledChargingPointOffline', keyValueData.ChargingPoint);
            //             break;

            //         //NF-958: ConnectToChargingPointCancelledChargingPointNotAccessible
            //         case 'ConnectToChargingPointCancelledChargingPointNotAccessible':
            //             // The charging point is temporarily unavailable
            //             item.Title = this.$translationService.formatTranslation('ChargingPointTemporarilyUnavailable');

            //             // The charging point {0} recently assigned to you is temporarily unavailable.
            //             item.Message = this.$translationService.formatTranslation('ConnectToChargingPointCancelledChargingPointNotAccessible', keyValueData.ChargingPoint);
            //             break;

            //         //NF-964: ChargeInterruptedChargingPointOffline
            //         case 'ChargeInterruptedChargingPointOffline':
            //             // Your charge has been interrupted
            //             item.Title = this.$translationService.formatTranslation('YourChargeInterrupted');

            //             // Charging of your vehicle at the charging point {ChargingPoint} has been interrupted following the shutdown of this charging point.
            //             item.Message = this.$translationService.formatTranslation('ChargeInterruptedChargingPointOffline', keyValueData.ChargingPoint);
            //             break;

            //         //NF-965: OfflineChargingPointUnassignedFromChargeBooking
            //         case 'OfflineChargingPointUnassignedFromChargeBooking':
            //             // Your charge has been interrupted
            //             item.Title = this.$translationService.formatTranslation('ChargingPointOutOfService');

            //             // Charging of your vehicle at the charging point {0} has been interrupted following the shutdown of this charging point.
            //             item.Message = this.$translationService.formatTranslation('OfflineChargingPointUnassignedFromChargeBooking', keyValueData.ChargingPoint);
            //             break;

            //         //NF-949: ConnectToChargingPoint
            //         case 'ConnectToChargingPoint':
            //             // Your charge has been interrupted
            //             item.Title = this.$translationService.formatTranslation('ChargingPointFreeNotification');

            //             // Charging of your vehicle at the charging point {0} has been interrupted following the shutdown of this charging point.
            //             item.Message = this.$translationService.formatTranslation('ConnectToChargingPoint', keyValueData.ChargingPoint);
            //             break;

            //         // NF-1173: CancelConnectToChargingPoint
            //         case 'CancelConnectToChargingPoint':
            //             // Request to connect the charging point cancelled
            //             item.Title = this.$translationService.formatTranslation('RequestToConnectChargingPointCancelled');

            //             // The request to connect your vehicle to charging point {0} has been cancelled. \n\nDon't worry, you're back in the queue.
            //             item.Message = this.$translationService.formatTranslation('RequestToConnectChargingPointCancelledBody', keyValueData.ChargingPoint);
            //             break;    

    
            //         case 'FuelLimitAlert':
            //             //Alert concerning your fuel limit
            //             item.Title = this.$translationService.formatTranslation('NotificationSubject_FuelLimitAlert');

            //             //You have already consumed over {0}% of your fuel budget for the period ending on {1}.
            //             let endDate = this.$filter('date')(keyValueData.EndDate, 'dd/MM/yyyy');
            //             item.Message = this.$translationService.formatTranslation('NotificationMessage_FuelLimitAlert', keyValueData.AlertLevel, endDate);
            //             break;


            //         case 'Announcement':
            //             //Alert concerning your fuel limit
            //             item.Title = keyValueData.Title;
            //             item.Message = keyValueData.Description;
            //             break;

            //         case 'NewDocument':
            //             item.Title = this.$translationService.formatTranslation('NotificationSubject_NewDocument');
            //             item.Message = this.$translationService.formatTranslation('NotificationMessage_NewDocument', keyValueData.DocumentType);
            //             break;

            //         case 'ChargeRequestCancelled': // NF-1173: when admin disconnect pending connection request
            //             item.Title = this.$translationService.formatTranslation('NotificationSubject_ChargeRequestCancelled');
            //             item.Message = this.$translationService.formatTranslation('NotificationMessage_ChargeRequestCancelled', keyValueData.DocumentType);
            //             break;

            //         default:
            //             item.Title = item.Type;
            //             break;
            //     }


            });

            //canMarkAsRead
            list.forEach((item) => {
                item.canMarkAsRead = !item.Urgent;
            })

            // Update the notification list
            this.list.splice(0, this.list.length);
            list.forEach((item) => {
                this.list.push(item);
            });


            this.total = list.length; // Update total notifications
            this.notificationService.updateNotificationCount(this.total)
        }, this.$message.error); // Handle error
    },

    /**
     * Marks a specific notification as read.
     * @param id{string}
     * @param $event{MouseEvent}
     * @returns {angular.IPromise<void>}
     */
    markAsRead: function (id, $event) {
        if ($event) {
            $event.preventDefault();
            $event.stopImmediatePropagation();
        }

        return this.notificationService.markAsRead(id)
            .then(() => {
                return this.refresh();
            }, this.$message.error)
            .finally(this.$Loading.blockUI())
    },


    /**
     * Open notification
     * @param item {NotificationModel}
     * @param $event
     */
    openNotification: function (item, $event) {
        if (!item) {
            return;
        }        
        
        this.notificationService.getNotification(item.Id)
            .then((notificationItem) => {                
                
                return this.notificationService.processNotification(notificationItem, {
                    isNotificationOnNotificationsModule: true,
                    $event: $event
                });
            }, (error) => {
                this.$message.error(error);
                // Follow logic of NF-1104, mark the notifcaion as read then refresh the list when liked entity have been deleted
                if (error.data.code == 'LinkedEntityIsNowDeleted') {
                    this.markAsRead(item.Id);
                }

                return Promise.reject(error);
            })
            .then((result) => {
                if (!(result && (
                    (result.name && result.url) || // is router
                    result.navigate)) // navigate: true
                ) {
                    return this.refresh().finally(this.$Loading.blockUI());
                } else {
                    return Promise.resolve(true);
                }
            }, this.$message.error)
            .finally(this.$Loading.blockUI());
    }
};


// Register the NotificationsCtrl controller with the AngularJS module
angular.module('internal.notifications').controller('NotificationsController', NotificationsController);

